import * as React from 'react';
import { observer, inject } from 'mobx-react';

// =====================================
// STORES
import { ICommonStore } from '../../store/CommonStore';

// =====================================
// COMPONENTS
import { Loader } from '../Layout/Loader';

@inject((allStores: any) => ({
    commonStore: allStores.store.commonStore as ICommonStore
}))

@observer
export default class Layout extends React.Component<{ commonStore?: ICommonStore }, any> {

    componentDidMount() {
        this.props.commonStore.init();
    }

    componentWillUnmount() {
        this.props.commonStore.reset();
    }

    render() {

        if (this.props.commonStore.isLoading) {
            return <Loader />;
        }

        return (
            <div>
                {this.props.children}
            </div>
        );
    }
}